module.exports = __webpack_public_path__ + "img/湖州市.931fb1ff.png";